// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import RichText from '../../../../../../common/atoms/RichText';
import ReactTooltip from '../../../../../../common/atoms/ReactToolTip';
import { getIconPath } from '../../../../../../../utils';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import { GlobalAccessibilityLabels } from '../../../../../../../utils/labels/globalAccessibility.labels';

const getCVVInfoRichText = ({ cvvCodeRichText }) => {
  return (
    <RichText
      richTextHtml={cvvCodeRichText}
      className="cvv-code-info"
      dataLocator="cvv-code-info"
    />
  );
};

const getCvvInfo = ({ cvvCodeRichText }) => {
  return (
    <ReactTooltip
      fontFamily="secondary"
      message={getCVVInfoRichText({ cvvCodeRichText })}
      aligned="right"
    >
      <Image
        height="15"
        width="15"
        src={getIconPath('info-icon')}
        alt={getLabelFromCopyOrFromTranslation(
          'global.accessibility.lbl_info_icon',
          GlobalAccessibilityLabels
        )}
      />
    </ReactTooltip>
  );
};

getCvvInfo.propTypes = {
  cvvCodeRichText: PropTypes.string,
};

getCvvInfo.defaultProps = {
  cvvCodeRichText: PropTypes.string,
};

getCVVInfoRichText.propTypes = {
  cvvCodeRichText: PropTypes.string,
};

getCVVInfoRichText.defaultProps = {
  cvvCodeRichText: PropTypes.string,
};

export default getCvvInfo;
